// extracted by mini-css-extract-plugin
export default {"search-group":"search-group--1r3Ts","search-group-header":"search-group-header--hkE12"};